<template>
  <g fill-rule="evenodd" fill="none">
    <path d="M-1.375-1.375h22.75v22.75h-22.75v-22.75z" />
    <path
      d="M11.422.047v8.531h8.531v2.844h-8.531v8.531H8.578v-8.531H.047V8.578h8.531V.047h2.844z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
